
import { computed, defineComponent } from "vue";
import { IonText } from "@ionic/vue";
import TradeRepository from "@/repositories/TradeRepository";

export default defineComponent({
  components: { IonText },

  setup() {
    const trades = TradeRepository.trades();

    const selectedIndex = computed(() => TradeRepository.selectedIndex());

    const type = TradeRepository.type();

    const numCells = type == "weekly" ? 13 : 12;

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const changeIndex = (index: number): void => {
      TradeRepository.setSelectedIndex(index);
    };

    return {
      trades,
      changeIndex,
      selectedIndex,
      type,
      numCells,
      monthNames,
    };
  },
});
